import { keepEditorFocusOnMouseDown as e } from "./keep-editor-focus.mjs";
import { useToolbarSheet as t } from "./toolbar-sheet.mjs";
import { forwardRef as n } from "react";
import { twMerge as r } from "tailwind-merge";
import { menuItemVariants as i } from "@systemeio/components";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Toolbar as s } from "@base-ui/react/toolbar";
//#region src/components/content-controls/toolbar-sheet-row.tsx
var c = n(({ active: n, className: c, closeOnClick: l = !0, icon: u, label: d, onClick: f, onMouseDown: p, ...m }, h) => {
	let { close: g, surface: _ } = t();
	return /* @__PURE__ */ o(s.Button, {
		"aria-pressed": n,
		className: r(i({
			state: n ? "active" : "default",
			surface: _
		}), "gap-2 text-left", c),
		onClick: (e) => {
			f?.(e), l && !e.defaultPrevented && g();
		},
		onMouseDown: e(p),
		ref: h,
		...m,
		children: [u, /* @__PURE__ */ a("span", {
			className: "min-w-0 flex-1 truncate",
			children: d
		})]
	});
});
c.displayName = "ToolbarSheetRow";
//#endregion
export { c as ToolbarSheetRow };
